import { useContext } from "react";

import { apiContext } from "./apiContext";

export const useApi = () => ({ api: useContext(apiContext) });
